import RoutesEspaceDetenteurs from './espace-detenteurs/routes';
import RoutesCompte from './compte/routes';
import RoutesPubliqueNousContacter from './nous-contacter/routes';
import RoutesPriveeNousContacter from './espace-detenteurs/nous-contacter/routes';
import RoutesPubliquesMentionsLegales from './mentions-legales/routes';
import RoutesPubliquesDonneesPersonnelles from './donnees-personnelles/routes';
import RoutesDeconnexion from './deconnexion/routes';
import RoutesPubliqueAccessibilite from './accessibilite/routes';
import { initSubRoutes } from '../utils/router';

const Routes = initSubRoutes({
    route: '',
    subroutes: {
        espaceDetenteurs: RoutesEspaceDetenteurs,
        compte: RoutesCompte,
        nousContacterPublique: RoutesPubliqueNousContacter,
        mentionsLegales: RoutesPubliquesMentionsLegales,
        donneesPersonnelles: RoutesPubliquesDonneesPersonnelles,
        accessibilite: RoutesPubliqueAccessibilite,
        nousContacterPrivee: RoutesPriveeNousContacter,
        deconnexion: RoutesDeconnexion,
    },
    nom: 'Accueil',
});

export default Routes;
